import Admin from './Admin.page';

export default Admin;
